import React from 'react';

const homeContent = {
    rightImage:{
        headerImg:<img alt='' src={require('../assets/images/pic-ht10.jpg')}/>,
        textContent:[
            {
                bgIconClass:'bg-yellow',
                headerIcon:<img alt='' src={require('../assets/images/policy.svg')} />,
                title:{ fa:'دقت و صحت اطلاعات ', en:'It is Easy' },
                description:{ 
                    fa:<span>مزیت و دلیل اصلی استقبال مخاطبان از زمان معرفی بورس ویو به بازار تاکنون، دقت بالا 
                        و صحت اطلاعات آن است که به دلیل هوشمند بودن ورود داده ها (بدون دخالت نیروی انسانی) و همچنین استانداردسازی و تست چندین باره در مورد صحت فرمول‎نویسی و محاسبات است</span>
                    , 
                    en:<span>You can access your account from everywhere at anytime and using any device that can run a simple web browser.</span>
                },
            },
            {
                bgIconClass:'bg-red',
                headerIcon:<img alt='' src={require('../assets/images/research.svg')} />,
                title:{ fa:'سرعت پردازش و ارائه اطلاعات ', en:'It is Accurate' },
                description:{ 
                    fa:<span>از آنجائیکه تمامی فرآیند ورود و محاسبه اطلاعات بصورت هوشمند صورت میپذیرد، لذا سرعت ارائه اطلاعات به مخاطبان در حداقل زمان ممکن و در لحظه انجام می‎شود. مزیت رقابتی که در پاسخ به نیاز تحلیلگران جهت بررسی 
                        و تحلیل اطلاعات بلافاصله پس از انتشار داده ‎ها توسط بورس ویو ارائه شده است</span>
                    , 
                    en:<span>We test every single piece of data and every line of code that we add to BourseView to make sure it is going to be delivered in the most accurate format.
                        All the processed data is being tested by experienced financial analyst to guaranty accuracy.</span>
                },
            }
        ]
    },
    leftImageTop:{
        headerImg:<img alt='' src={require('../assets/images/pic-ht5.jpg')}/>,
        button:{textFa:'ورود آزمایشی', textEn:'Free Trial'},
        buttonLink:{link: window.location.href + 'home/#', target:''},
        textContent:[
            {
                title:{ fa:'قابلیت استفاده آزمایشی', en:'Quality is our delivery' },
                description:{ 
                    fa:<span>تمامی اطلاعات و امکانات توسعه داده شده برای بورس ویو قبل از ارائه به کاربر بارها
                        تست می‌شوند تا اطمینان حاصل شود که کاربران از همان ابتدا تجربه مطلوبی در مواجهه با امکانات جدید خواهند داشت.<br/><br/>
                        امکان استفاده آزمایشی از نسخه حرفه ای به مدت 48 ساعت میسر است   </span>
                    , 
                    en:<span>All information and features developed for Bourseview View are tested repeatedly before being provided to the user
                        to ensure that users have a desirable experience of the new features from the beginning. 
                        The trial version of the Pro version can be used for 48 hours</span>
                },
            }
        ]
    },
    leftImageBottom:{
        headerImg:<img alt='' src={require('../assets/images/pic-tb1.jpg')}/>,
        // button:{textFa:'ورود آزمایشی', textEn:'Free Trial'},
        textContent:[
            {
                title:{ fa:'محصولات', en:'Products' },
                description:{ 
                    fa:<span><span><b>محصول اصلی</b>: سامانه جامع تحلیل بنیادی بورس ویو (BourseView.Com) محصولی شناخته شده در بازار مالی ایران است که توسط شرکت پردازش اطلاعات مالی مفید ارائه می‎شود و با فراهم کردن اطلاعات مالی دقیق و سریع و رابط کاربری ساده جهت تحلیل، مقایسه، گزارش‎گیری و ذخیره سازی اطلاعات در سطوح سهم، صنعت و بازار به تصمیم گیری بهینه و صرفه جوئی زمان سرمایه‎گذاران و تحلیلگران کمک می‎کند. </span><br/><br/>
                        <span><b>دیگر محصولات</b>: وب سرویس بورس ویو (API)  از دیگر محصولات شرکت پردازش اطلاعات مالی مفید است که کلیه اطلاعات موجود در سامانه بورس ویو در آن قابل فراخوانی مستقیم است. </span>
                    </span>
                    , 
                    en:<span><span><b>Main product</b>:  Bourse View the financial data platform (BourseView.Com) is a well-known product in the Iranian financial market, provided by Pooya Finance, providing fast and accurate financial information and a simple interface for analysis, comparison, reporting, collecting and storing information at the level of stock, industry and market, helps to make the best decisions and save time for investors and analysts.</span><br/><br/>
                    <span><b>Other products</b>: The Bourse View Web Service (API and the Excel Add-in) are other Pooya Finance products where all information on the Bourse View system can be directly accessed.</span>
                    </span>
                },
            }
        ]
    },
    selectableImage:{
        title:{fa:'',en:''},
        description:{fa:'',en:''},
        textContent:[
            {
                bgIconClass:'bg-orange',
                icon:<img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
                text:{fa:'سامانه جامع تحلیل بنیادی ',
                    en:'Bourseview'},
                img:<img alt='' src={require('../assets/images/pic-ht11.jpg')} />,
            },
            {
                bgIconClass:'bg-orange',
                icon:<img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
                text:{fa:'وب سرویس بورس ویو',
                    en:'API'},
                img:<img alt='' src={require('../assets/images/pic-tb2.png')} />,
            },
            // {
            //     bgIconClass:'bg-orange',
            //     icon:<img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
            //     text:{fa:'اَد-این اکسل بورس ویو ',
            //         en:'Excel add-in'},
            //     img:<img alt='' src={require('../assets/images/pic-tb3.jpg')} />,
            // }

        ]
    }

}


export default homeContent;